import template from './languageSelector.html';
import controller from './languageSelector.controller';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    cssClass: '@',
  },
};

export default component;
